var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        pre: true,
        attrs: {
          class:
            "discus-wrapper xs-12 xs-f-small md-f-medium lg-f-small max-at-tweak",
        },
      },
      [
        _c("div", { pre: true, attrs: { class: "padded-wrap xs-12" } }, [
          _c("div", { pre: true, attrs: { id: "disqus_thread" } }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }